import { Modal } from 'antd';
import React from 'react';
import './style.scss';
import { ModalProps } from 'antd';
import { useRouter } from 'next/navigation';

type Props = {
  signUpModalOpen: boolean;
  handleSignUpModal: any;
  type: string;
};

const SignOut = ({ signUpModalOpen, handleSignUpModal, type }: Props) => {
  const router = useRouter();
  return (
    <Modal open={signUpModalOpen} footer={null} onCancel={() => handleSignUpModal(false)}>
      <div className="signout">
        <span> Are you sure you want to logout? </span>
        <div className="button-group">
          <button
            className="button-cancel"
            onClick={() => {
              handleSignUpModal(false);
            }}
          >
            {' '}
            Cancel{' '}
          </button>
          <button
            className="button-yes"
            onClick={() => {
              type === 'admin' ? router.push('/auth/admin-login') : router.push('/auth/login');
            }}
          >
            {' '}
            Yes, Logout{' '}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SignOut;
